import Radium from "radium";
import React from "react";

import { IAuthorization } from "@common/models";
import { Remo } from "@components";
import AuthorizationsList from "./authorization-list";
import styles from "./authorization.styles";
import EditAuthorization from "./edit-authorization";

export interface IAuthorizationsProps {
  authorizations: IAuthorization[];
  userId: string;
}

export interface IAuthorizationsActions {
  updateAuthorizations: (userId: string, claims: string[]) => void;
}

export interface IAuthorizationsState {
  isEditing: boolean;
  adminUserIsChecked?: any;
  apiUserIsChecked?: any;
  basicUserIsChecked?: any;
}

class Authorizations extends React.Component<
  IAuthorizationsProps & IAuthorizationsActions,
  IAuthorizationsState
> {
  constructor(props) {
    super(props);
    this.state = { isEditing: false };
  }

  public render() {
    const listItemStyle = { ...styles.listItem, fontSize: "13px" };
    const editLinkStyle = {
      ...listItemStyle,
      justifyContent: "flex-end",
      width: "20%",
      flex: "1"
    };

    const rowStyle = { ...styles.row, alignItems: "left" };
    const { authorizations } = this.props;
    const userHasRoles = !!authorizations;

    return (
      <div>
        <div style={styles.rowHeader as any} className="rowHeader">
          <div style={listItemStyle as any}>Brukerrettigheter</div>
        </div>
        <div style={rowStyle as any} className="row">
          <AuthorizationsList authorizations={authorizations} />
          <div style={editLinkStyle as any}>
            <div
              onClick={() => this.setState({ isEditing: true })}
              style={styles.listLinkStyle as any}
            >
              {userHasRoles ? "Rediger" : "Opprett rolle"}
            </div>
          </div>
        </div>
        <Remo show={this.state.isEditing}>
          <EditAuthorization
            currentAuthorizations={authorizations}
            updateAuthorizations={this.updateAuthorizations}
            closeModal={() => this.setState({ isEditing: false })}
          />
        </Remo>
      </div>
    );
  }

  private updateAuthorizations = (claims: string[]) => {
    this.setState(
      {
        isEditing: false
      },
      () => {
        this.props.updateAuthorizations(this.props.userId, claims);
      }
    );
  };
}

export default Radium(Authorizations);
